import { StripesConnectedSource, } from "@folio/stripes/smart-components";
export var createStripesSource = function (_a) {
    var ky = _a.ky, data = _a.data, totalRecords = _a.totalRecords, isLoading = _a.isLoading, isError = _a.isError, isLoaded = _a.isLoaded, fetchMore = _a.fetchMore, formatMessage = _a.formatMessage, customErrorMessage = _a.errorMessage;
    var source = new StripesConnectedSource({}, ky);
    var errorMessage = customErrorMessage !== null && customErrorMessage !== void 0 ? customErrorMessage : (formatMessage
        ? formatMessage({ id: "ui-br-legaldeposits.error.loading.data" })
        : "Error loading data");
    source.update = function () { };
    source.records = function () { return data; };
    source.resultCount = function () { return totalRecords; };
    source.totalCount = function () { return totalRecords; };
    source.pending = function () { return isLoading; };
    source.loaded = function () { return isLoaded; };
    source.failure = function () { return (isError ? { message: errorMessage } : null); };
    source.failureMessage = function () { return errorMessage; };
    source.successfulMutations = function () { return []; };
    source.fetchMore = function () { return fetchMore; };
    return source;
};
